import YAML from "yaml";

import { DocumentMetadataSchema } from "@moment/api-collab/api-types";

import { isDesktopAppMode } from "~/auth/interop/common";
import { getGiteaApiUrl, giteaClient } from "~/utils/gitea";

import { authenticationActorRef, waitForAccessTokenSilently } from "../machines/authentication";

const getAccessToken = async () =>
	isDesktopAppMode() ? await waitForAccessTokenSilently(authenticationActorRef) : undefined;

export const giteaApi = {
	document: {
		metadata: {
			read: async (workspaceName: string, documentId: string) => {
				const accessToken = await getAccessToken();

				const headers = new Headers();
				headers.set("Accept", "application/json");

				if (accessToken) {
					headers.set("Authorization", `Bearer ${accessToken}`);
				}

				const response = await fetch(
					`${getGiteaApiUrl()}/api/v1/repos/${workspaceName}/${documentId}/raw/moment.yml?ref=main`,
					{
						headers,
					}
				);

				if (response.status === 404) {
					console.error("Failed to fetch public document metadata", {
						workspaceName,
						documentId,
						response,
					});

					throw new Error("Failed to fetch public document metadata");
				} else if (!response.ok) {
					console.error("Failed to fetch public document metadata", {
						workspaceName,
						documentId,
						response,
					});
					throw new Error("Failed to fetch public document metadata");
				}
				const text = await response.text();
				const metadata = YAML.parse(text);

				return DocumentMetadataSchema.parse(metadata);
			},
		},
		delete: async (workspaceName: string, documentId: string) => {
			const accessToken = await getAccessToken();

			const gitea = giteaClient(accessToken);

			await gitea.repos.repoDelete(workspaceName, documentId);
		},
	},
};
